import * as React from 'react';

function SvgTime(props) {
  return (
    <svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M10.648 9.291a.53.53 0 01-.178-.03L6.628 7.888a.53.53 0 01-.352-.498V4.312a.53.53 0 011.06 0v2.706l3.484 1.245a.53.53 0 01-.178 1.032l.006-.004zM7.002 0A7 7 0 1014 7a7.008 7.008 0 00-6.998-7zm0 12.888a5.888 5.888 0 110-11.774 5.888 5.888 0 010 11.773z" />
    </svg>
  );
}

export default SvgTime;
